import { Application } from '@hotwired/stimulus';

const stimulus = Application.start();

window.Stimulus = stimulus;
stimulus.debug = false;

export { stimulus };
